import axios, { getAuthHeader } from './client.ts';
import services from './services.ts';

export const ENDPOINTS = {
  LOGIN: `${services.AUTHENTICATION}/user`,
  LOGOUT: `${services.AUTHENTICATION}/token`,
  // LOGOUT: (token: string) => `${services.AUTHENTICATION}/token/${token}`,
  LOGOUT_EVERYWHERE: `${services.AUTHENTICATION}/token`,
  CHECK_EMAIL_ADDRESS: (emailAddress: string) => `${services.AUTHENTICATION}/email/${emailAddress}`,
  RESET_PASSWORD: (token?: string) => `${services.AUTHENTICATION}/reset-password/${token}`,
  UPDATE_USER_DETAILS: (userId: string) => `${services.AUTHENTICATION}/user/${userId}`,
  UPDATE_PASSWORD: `${services.AUTHENTICATION}/user?updateType=password`,
};

export const checkEmailAddress = (emailAddress: string) =>
  axios.get(ENDPOINTS.CHECK_EMAIL_ADDRESS(emailAddress.toLowerCase()));

export const resetPassword = (data: Record<string, string>, token?: string) =>
  axios.put(ENDPOINTS.RESET_PASSWORD(token), data);

export const login = (credentials: Record<string, string>) =>
  axios.put(ENDPOINTS.LOGIN, credentials, {
    headers: { 'Content-Type': 'application/json' },
  });

export const updateUserDetails = (data: Record<string, unknown>, userId: string, token: string) =>
  axios.patch(ENDPOINTS.UPDATE_USER_DETAILS(userId), data, {
    headers: { ...{ 'Content-Type': 'application/json' }, ...getAuthHeader(token) },
  });

export const updatePassword = (data: Record<string, string>, token: string) =>
  axios.patch(ENDPOINTS.UPDATE_PASSWORD, data, {
    headers: { ...{ 'Content-Type': 'application/json' }, ...getAuthHeader(token) },
  });
